// extracted by mini-css-extract-plugin
export default {"searchBg":"SearchField_searchBg__1XxZk"};